// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","563":"cb355538"}[chunkId] + "-" + {"245":"133ae9d5506250a56ba0","453":"eb5505c9e788d0821004","563":"e1a40b1ae6852937de57"}[chunkId] + ".js";
};